import React from 'react'
import MaterialSymbol from '../material-symbol'

const CreditCard = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="credit_card" {...props} />
))

CreditCard.displayName = 'CreditCard'

export default CreditCard
